var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"btn-rounded",attrs:{"id":"contrato-verificar-abrir","color":"#52a3f7","type":"filled","icon":"add_circle_outline","to":{name: 'cadastrar-entidade'}}},[_vm._v("Adicionar")])}
var staticRenderFns = []

export { render, staticRenderFns }